import {CanBeSignal, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {ActionFunction} from './Wrap';

export function Visibility(visible: CanBeSignal<boolean>): ActionFunction {
    const result: ActionFunction = (instance, done) => {
        instance.visible = getProp(visible);
        done();
    };

    return result;
};
